/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentUrl } from '../../models/document-url';

export interface ApiIdpSubmissionsDirectDocumentsPdfPost$Params {
      body?: DocumentUrl
}

export function apiIdpSubmissionsDirectDocumentsPdfPost(http: HttpClient, rootUrl: string, params?: ApiIdpSubmissionsDirectDocumentsPdfPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiIdpSubmissionsDirectDocumentsPdfPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiIdpSubmissionsDirectDocumentsPdfPost.PATH = '/api/idp/submissions-direct/documents/pdf';
